import { render, staticRenderFns } from "./LazyWrapper.vue?vue&type=template&id=743a88c7&"
import script from "./LazyWrapper.vue?vue&type=script&lang=js&"
export * from "./LazyWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports